// Mirror of apps/backend-strapi/src/api/gpt-conversation/utils/planTransitionTool.js
// PROCEED_INTENT_REGEX. Kept in sync by convention — if you change one,
// change the other. The frontend uses this in `ready_to_generate` phase
// to detect "génère / vas-y / let's go"-style user messages and skip
// straight to the CreateProjectFromAiGraph modal instead of treating
// the message as a refinement turn.

const PROCEED_INTENT_REGEX = new RegExp(
  [
    "g[ée]n[èé]r",
    "consolid",
    "compil",
    "produis",
    "cr[ée]e",
    "vas[- ]?y",
    "vas y",
    "on y va",
    "on y est",
    "allons[- ]?y",
    "let'?s? go",
    "let'?s? do it",
    "fonce",
    "lance[- ]toi",
    "lance[- ]le",
    "envoie",
    "d[ée]marre",
    "demarre",
    "c'est parti",
    "feu vert",
    "passe (à la|en) g[ée]n[ée]ration",
    "passe au plan",
    "valide le brief",
    "valide le plan",
    "le brief est complet",
  ].join("|"),
  "i",
);

export const userMessageSignalsProceed = (message: string | undefined | null): boolean => {
  if (typeof message !== "string" || !message.trim()) {
    return false;
  }
  return PROCEED_INTENT_REGEX.test(message);
};
